// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import SCComboBox from '@/components/sc-controls/form-controls/sc-combobox';
import SCDropdownList from '@/components/sc-controls/form-controls/sc-dropdownlist';
import Fetch from '@/utils/Fetch';

function WorkflowSelector({selectedWorkflow, setSelectedWorkflow, searchable = true, required = true, pageSize = 20,  error, accessStatus}: any) {

  const handleChange = (value: any) => {
    setSelectedWorkflow(value);
  };

  const getData = async (skipIndex: any, take: any, filter: any) => {

    let params = {
        pageSize: take, pageIndex: skipIndex, 
        searchPhrase: filter, 
        SortExpression: "", SortDirection: "",
    };

    const request = await Fetch.post({
        url: `/Workflow/GetWorkflows`,
        params: params
    });
    setData(request.Results);
  };

  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    getData();
  }, []);

  return (
      <SCDropdownList 
        name="Workflow"
        value={selectedWorkflow}
        dataItemKey="ID"
        textField="Name"
        onChange={handleChange}
        options={data}
        label="Workflow"
        required={required}
        extraClasses="input-width"
      />
  );
}

export default WorkflowSelector;
